// Retail marketplaces
const US_MARKETPLACE_ID = "ATVPDKIKX0DER"
const UK_MARKETPLACE_ID = "A1F83G8C2ARO7P"
const DE_MARKETPLACE_ID = "A1PA6795UKMFR9"
const JP_MARKETPLACE_ID = "A1VC38T7YXB528"

export const isJPMarketplace = (marketplaceId: string) => marketplaceId === JP_MARKETPLACE_ID

// Returns the absolute url for each of the retail sites with video and global
export const getMarketplaceUrl = (marketplaceId: string) => {
  switch (marketplaceId) {
    case US_MARKETPLACE_ID:
      return "https://www.amazon.com"
    case UK_MARKETPLACE_ID:
      return "https://www.amazon.co.uk"
    case DE_MARKETPLACE_ID:
      return "https://www.amazon.de"
    case JP_MARKETPLACE_ID:
      return "https://www.amazon.co.jp"
    default:
      return "https://www.primevideo.com"
  }
}
